const SLIDE_ACTIVE_TABS = {
  SLIDE_TYPES: 1,
  CONTENT: 2, // or Templates Tab for content slide
  DESIGN: 3,
  AUDIO: 4,
}

export default SLIDE_ACTIVE_TABS
